const prefix = process.env.VUE_APP_API_PREFIX

export default [
  {
    name: 'add',
    path: `${prefix}/domain/add`,
    method: 'post',
    params: {
      domain: '',// 域名
      ip: '', // 源站ip 或域名
      srcProtocol: '', // 回源协议类型
      srcPort: '', //回源端口
      srcDomain: '', // 回源host  使用访问域名的时候传空
      https: '0', // 有无证书 1有证书， 0 没证书
      cert: '', // 证书 有证书 传 没证书放空
      mode: '', // 防护模式 SYSTEM\ REFER
      referenceDomain: '', // c参考域名,
      packageId: '', // 套餐ID
      line: '' // 套餐线路
    },
    desc: '新增域名'
  },
  {
    name: 'referDomainOptions',
    path: `${prefix}/domain/getDomainByPid`,
    method: 'get',
    params: {
      pid: '' // 产品ID
    },
    desc: '获取参考域名'
  },
  {
    name: 'certOptions',
    path: `${prefix}/certificate/getCustCertList`,
    method: 'get',
    params: {},
    desc: '获取证书列表'
  },
  {
    name: 'packageList',
    path: `${prefix}/package/getUserSimpleList`,
    method: 'get',
    params: {},
    desc: '获取套餐列表'
  },
  {
    name: 'list',
    path: `${prefix}/domain/list/all`,
    method: 'get',
    params: {},
    desc: '获取域名列表'
  },
  {
    name: 'listWaap',
    path: `${prefix}/domain/list/waap`,
    method: 'get',
    params: {
      domain: '',
      groupId: '',
      ip: ''
    },
    desc: '获取域名列表-waap 状态混合'
  },
  {
    name: 'batchDelete',
    path: `${prefix}/domain/delete_batch`,
    method: 'post',
    params: {
      domains: '' // 域名列表个;分隔
    },
    desc: '删除域名'
  },
  {
    name: 'getDomainCert',
    path: `${prefix}/domain/detail_https`,
    method: 'get',
    params: {
      domain: ''
    },
    desc: '获取域名证书'
  },
  {
    name: 'relateCert',
    path: `${prefix}/domain/cert_relate`,
    method: 'post',
    params: {
      domain: '',
      cert: '',
      https: ''
    },
    desc: '关联证书'
  },
  {
    name: 'getDomainConfig',
    path: `${prefix}/domain/config/detail`,
    method: 'get',
    params: {
      domains: ''
    },
    desc: '获取域名配置'
  },
  {
    name: 'editDomainConfig',
    path: `${prefix}/domain/edit/config`,
    method: 'post',
    params: {
      domains: '', // 域名列表 ;分隔
      ips: '', // 源站ip 或域名`
      srcProtocol: '', // 回源协议类型
      srcPort: '', //回源端口
      srcDomain: '', // 回源host  使用访问域名的时候传空
      line: '' // 线路
    },
    desc: '修改域名配置'
  },
  {
    name: 'batchEditDomainConfig',
    path: `${prefix}/domain/batch/edit/config`,
    method: 'post',
    params: {
      domains: '', // 域名列表 ;分隔
      ips: '', // 源站ip 或域名`
      srcProtocol: '', // 回源协议类型
      srcPort: '', //回源端口
      srcDomain: '', // 回源host  使用访问域名的时候传空
      isSrcDomain: '', // 是否修改回源host 1 修改 0 不修改
      line: '' // 线路
    },
    desc: '批量修改域名配置'
  },
  {
    name: 'getSpeedConfigDict',
    path: `${prefix}/dict/getSpeedConfig`,
    method: 'get',
    /*mock:[
      {
        "category": "",
        "child": [
          {
            "category": "",
            "child": [
              {}
            ],
            "component": "",
            "description": "",
            "dictKey": "equal", // 传给后端值
            "firstLetter": "",
            "id": 0,
            "type": "",
            "value": "等于", // 中文名称
            "valueEn": ""
          }
        ],
        "component": "input", // 组件 input / select
        "description": "",
        "dictKey": "URI", // 传给后端值
        "firstLetter": "",  // 是否 额外字段 key
        "id": 0,
        "type": "",
        "value": "URI", // 中文名称
        "valueEn": "URI" // 英文名称
      }
    ],*/
    params: {
      type: ''
    },
    desc: '获取加速配置字典'
  },
  {
    name: 'getAccelerationConfig',
    path: `${prefix}/domain/get/speedConfig`,
    method: 'get',
   /* mock:{
      "domainNames": "",
      "brotli": "",
      "dataOpt": 0,
      "gzip": "",
      "http2fig": "",
      "srchttp2fig": "",
      "httpsOptimize": "",
      "ipv6": "",
      "websocket": 0,
      "querystringurl": {
        "key": "",
        "type": ""
      },
      "customCache": [
        {
          "cacheTime": 10,
          "commonType": "",
          "dataId": "",
          "fileTypes": "",
          "priority": "1",
          "radioTime": 1,
          "rule": "缓存规则",
          "scUri": "",
          "speedInputDtos": [
            {
              "comparison": "equals",
              "params": "URI",
              "firstValue":"key",
              "value": "name"
            }
          ],
          "timeSelect": "sec",
          "uri": "",
          "urlMatch": ""
        }
      ],
      "customCacheIds": [],
      "urlRedirect": [
        {
          "dataId": "",
          "header": "",
          "newUrl": "",
          "oldUrl": "",
          "priority": "",
          "protocol": 0,
          "scHeader": "",
          "scUa": "",
          "scUri": "",
          "speedInputDtos": [
            {
              "comparison": "",
              "params": "",
              "value": ""
            }
          ],
          "statusCode": "",
          "ua": "",
          "unOldUrl": "",
          "uri": "",
          "urlpattern": ""
        }
      ],
      "httpHead": [
        {
          "controldirection": "",
          "custompattern": "",
          "dataId": "",
          "header": "",
          "httpheadfield": "",
          "newvalue": "",
          "opertype": "",
          "priority": "",
          "rule": "",
          "scHeader": "",
          "scUa": "",
          "scUri": "",
          "speedInputDtos": [
            {
              "comparison": "",
              "params": "",
              "value": ""
            }
          ],
          "ua": "",
          "uri": ""
        }
      ],
      "httpHeadIds": [],
      "urlredirectIds": []

    },*/
    params: {
      domains: ''
    },
    desc: '获取加速配置'
  },
  {
    name: 'deployAccelerationConfig',
    path: `${prefix}/domain/deploy`,
    method: 'post',
    params: {
      "isCover": null,
      "brotli": "",
      "activeConfig": [],
      "customCache": [
        /*{
          "cacheTime": 0,
          "commonType": "",
          "dataId": "",
          "fileTypes": "",
          "priority": "",
          "radioTime": 0,
          "rule": "",
          "scUri": "",
          "speedInputDtos": [
            {
              "comparison": "",
              "params": "",
              "value": ""
            }
          ],
          "timeSelect": "",
          "uri": "",
          "urlMatch": ""
        }*/
      ],
      "dataOpt": 0,
      "domainNames": "",
      "gzip": "",
      "http2fig": "",
      "httpHead": [
        /*{
          "controldirection": "",
          "custompattern": "",
          "dataId": "",
          "header": "",
          "httpheadfield": "",
          "newvalue": "",
          "opertype": "",
          "priority": "",
          "rule": "",
          "scHeader": "",
          "scUa": "",
          "scUri": "",
          "speedInputDtos": [
            {
              "comparison": "",
              "params": "",
              "value": ""
            }
          ],
          "ua": "",
          "uri": ""
        }*/
      ],
      "httpsOptimize": "",
      "ipv6": "",
      "querystringurl": {
        "key": "",
        "type": ""
      },
      "srchttp2fig": "",
      "urlRedirect": [
        /*{
          "dataId": "",
          "header": "",
          "newUrl": "",
          "oldUrl": "",
          "priority": "",
          "protocol": 0,
          "scHeader": "",
          "scUa": "",
          "scUri": "",
          "speedInputDtos": [
            {
              "comparison": "",
              "params": "",
              "value": ""
            }
          ],
          "statusCode": "",
          "ua": "",
          "unOldUrl": "",
          "uri": "",
          "urlpattern": ""
        }*/
      ],
      "websocket": 0
    },
    desc: '修改加速配置'
  },
  {
    name: 'checkEnableDomains',
    path: `${prefix}/domain/checkEnableDomains`,
    method: 'post',
    params: {},
    desc: '域名开启前检测'
  },
  {
    name: 'disableDomains',
    path: `${prefix}/domain/disableDomains`,
    method: 'post',
    params: {
      domains: ''
    },
    desc: '域名禁用'
  },
  {
    name: 'enableDomains',
    path: `${prefix}/domain/enableDomains`,
    method: 'post',
    params: {
      domains: ''
    },
    desc: '域名启用'
  }
]
